import React from 'react';
import {CircularProgress, Typography} from '@mui/material';
import {StyledBox} from './styles';
import {LoadingProps} from './types';

export function Loading({
	fullscreen,
	text,
	footer,
	minHeight,
	boxProps,
	textColor,
	fullWidth = true,
	...progressProps
}: LoadingProps) {
	return (
		<StyledBox $fullWidth={fullWidth} $fullscreen={fullscreen} sx={{minHeight}} {...boxProps}>
			<CircularProgress {...progressProps} />
			{text ? (
				<Typography color={textColor ?? 'primary'} variant="body1">
					{text}
				</Typography>
			) : null}
			{footer}
		</StyledBox>
	);
}
